import React, { useState } from 'react';
import useTsrEnquirySubmit from '../hooks/useTsrEnquirySubmit';

function HomeCallbackForm({
	formId = '3319',
	uid = '6a145adc71c42',
	buttonLabel = 'Call Me Back',
}) {
	const [form, setForm] = useState({
		name: '',
		phone: '',
		email: '',
		company: '',
		planning: '',
	});
	const { submitting, message, clearMessage, handleSubmit: submitEnquiry } = useTsrEnquirySubmit({
		successMessage: 'Thank you! We will call you back shortly.',
	});

	const handleChange = (field) => (e) => {
		setForm((prev) => ({ ...prev, [field]: e.target.value }));
		clearMessage();
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const ok = await submitEnquiry({
			formType: 'HomeCallback',
			name: form.name.trim(),
			phone: form.phone.trim(),
			email: form.email.trim(),
			company: form.company.trim(),
			planning: form.planning.trim(),
		});
		if (ok) {
			setForm({ name: '', phone: '', email: '', company: '', planning: '' });
		}
	};

	const responseClassName = [
		'forminator-response-message',
		message.type === 'success' ? 'forminator-success' : '',
		message.type === 'error' ? 'forminator-error' : '',
	]
		.filter(Boolean)
		.join(' ');

	return (
		<div className="elementor-shortcode">
			<form
				id={`forminator-module-${formId}`}
				className={`forminator-ui forminator-custom-form forminator-custom-form-${formId} forminator-design--basic forminator_ajax tsr-home-callback-form`}
				method="post"
				data-forminator-render="0"
				data-form-id={formId}
				data-color-option="theme"
				data-design="basic"
				data-grid="open"
				data-uid={uid}
				onSubmit={handleSubmit}
				noValidate
			>
				<div
					role="alert"
					aria-live="polite"
					className={responseClassName}
					aria-hidden={!message.text}
				>
					{message.text}
				</div>

				<div className="forminator-row">
					<div id="name-1" className="forminator-field-name forminator-col forminator-col-12">
						<div className="forminator-field">
							<label
								htmlFor={`forminator-field-name-1_${uid}`}
								id={`forminator-field-name-1_${uid}-label`}
								className="forminator-label"
							>
								Name <span className="forminator-required">*</span>
							</label>
							<input
								type="text"
								name="name-1"
								placeholder=""
								id={`forminator-field-name-1_${uid}`}
								className="forminator-input forminator-name--field"
								aria-required="true"
								autoComplete="name"
								required
								value={form.name}
								onChange={handleChange('name')}
							/>
						</div>
					</div>
				</div>

				<div className="forminator-row">
					<div id="phone-1" className="forminator-field-phone forminator-col forminator-col-12">
						<div className="forminator-field">
							<label
								htmlFor={`forminator-field-phone-1_${uid}`}
								id={`forminator-field-phone-1_${uid}-label`}
								className="forminator-label"
							>
								Phone Number <span className="forminator-required">*</span>
							</label>
							<input
								type="tel"
								name="phone-1"
								placeholder=""
								id={`forminator-field-phone-1_${uid}`}
								className="forminator-input forminator-field--phone"
								aria-required="true"
								autoComplete="tel"
								required
								value={form.phone}
								onChange={handleChange('phone')}
							/>
						</div>
					</div>
				</div>

				<div className="forminator-row">
					<div id="email-1" className="forminator-field-email forminator-col forminator-col-12">
						<div className="forminator-field">
							<label
								htmlFor={`forminator-field-email-1_${uid}`}
								id={`forminator-field-email-1_${uid}-label`}
								className="forminator-label"
							>
								Email Address <span className="forminator-required">*</span>
							</label>
							<input
								type="email"
								name="email-1"
								placeholder=""
								id={`forminator-field-email-1_${uid}`}
								className="forminator-input forminator-email--field"
								aria-required="true"
								autoComplete="email"
								required
								value={form.email}
								onChange={handleChange('email')}
							/>
						</div>
					</div>
				</div>

				<div className="forminator-row">
					<div id="text-2" className="forminator-field-text forminator-col forminator-col-12">
						<div className="forminator-field">
							<label
								htmlFor={`forminator-field-text-2_${uid}`}
								id={`forminator-field-text-2_${uid}-label`}
								className="forminator-label"
							>
								Company/ Society Name
							</label>
							<input
								type="text"
								name="text-2"
								placeholder=""
								id={`forminator-field-text-2_${uid}`}
								className="forminator-input forminator-name--field"
								autoComplete="organization"
								value={form.company}
								onChange={handleChange('company')}
							/>
						</div>
					</div>
				</div>

				<div className="forminator-row">
					<div id="text-1" className="forminator-field-text forminator-col forminator-col-12">
						<div className="forminator-field">
							<label
								htmlFor={`forminator-field-text-1_${uid}`}
								id={`forminator-field-text-1_${uid}-label`}
								className="forminator-label"
							>
								What are you planning?
							</label>
							<input
								type="text"
								name="text-1"
								placeholder=""
								id={`forminator-field-text-1_${uid}`}
								className="forminator-input forminator-name--field"
								value={form.planning}
								onChange={handleChange('planning')}
							/>
						</div>
					</div>
				</div>

				<div className="forminator-row forminator-row-last">
					<div className="forminator-col">
						<div className="forminator-field">
							<button
								type="submit"
								className="forminator-button forminator-button-submit"
								disabled={submitting}
							>
								{submitting ? 'Sending...' : buttonLabel}
							</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
}

export default HomeCallbackForm;
